import ButtonSize from '@/Enums/ButtonSize.enum';
import type { CSSProperties } from 'react';

export interface ButtonSizeSx {
  iconSx: CSSProperties;
  buttonSx: CSSProperties;
}

const iconSxMap: Record<ButtonSize, CSSProperties> = {
  [ButtonSize.Small]: { width: 18, height: 18 },
  [ButtonSize.Medium]: { width: 20, height: 20 },
  [ButtonSize.Other]: {},
};

const buttonSxMap: Record<ButtonSize, CSSProperties> = {
  [ButtonSize.Small]: { height: 32, width: 35, minWidth: 'unset' },
  [ButtonSize.Medium]: { height: 34, width: 35, minWidth: 'unset' },
  [ButtonSize.Other]: { height: 40, width: 44, padding: '8px' },
};

const enumValues = new Set<ButtonSize>(Object.values(ButtonSize) as ButtonSize[]);

const hasSize = (val: unknown): val is ButtonSize => enumValues.has(val as ButtonSize);

export const getDownloadButtonSizeSx = (size: unknown = ButtonSize.Other): ButtonSizeSx => {
  const normalized = hasSize(size) ? size : ButtonSize.Other;
  return { iconSx: iconSxMap[normalized], buttonSx: buttonSxMap[normalized] };
};
